import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const socialDistribution = {
  fetchSocialDistribution: lazyModuleMethod(
    () => import('./fetchSocialDistribution'),
    'default'
  ),
  fechAITextSocialDistribution: lazyModuleMethod(
    () => import('./fechAITextSocialDistribution'),
    'default'
  ),
  createSocialDistribution: lazyModuleMethod(
    () => import('./createSocialDistribution'),
    'default'
  ),
  updateSocialDistribution: lazyModuleMethod(
    () => import('./updateSocialDistribution'),
    'default'
  ),
  updateSocialDistributions: lazyModuleMethod(
    () => import('./updateSocialDistributions'),
    'default'
  ),
  deleteSocialDistribution: lazyModuleMethod(
    () => import('./deleteSocialDistribution'),
    'default'
  ),
  fetchSocialChannels: lazyModuleMethod(
    () => import('./fetchSocialChannels'),
    'default'
  ),
  createSocialDistributionMass: lazyModuleMethod(
    () => import('./createSocialDistributionMass'),
    'default'
  ),
  fetchSocialPost: lazyModuleMethod(
    () => import('./fetchSocialPost'),
    'default'
  ),
}
